export default __webpack_public_path__ + "static/media/treasure-logo.ea4d271b.png";